module.exports = __webpack_public_path__ + "img/begravd_t-shirt_bones.c46c6ec0.png";